import {TypedModalActionTypes} from '../../constants/actionType';

export const showModalType =
  (modalType, data = {}, keepCurrentData = false) =>
  (dispatch, getState) => {
    const {typedModalState} = getState();
    const {data: currentData} = typedModalState;

    dispatch({
      type: TypedModalActionTypes.SHOW_TYPED_MODAL,
      modalType,
      data: keepCurrentData ? {...currentData, ...data} : data,
    });
  };

export const setTypedModalData = (data = {}) => ({type: TypedModalActionTypes.SET_MODAL_DATA, data});

export const hideTypedModal = (isResetState) => ({type: TypedModalActionTypes.HIDE_TYPED_MODAL, isResetState});

export const appendTypedModalData =
  (appendedData = {}) =>
  (dispatch, getState) => {
    const {typedModalState} = getState();
    const {data} = typedModalState;

    dispatch({type: TypedModalActionTypes.SET_MODAL_DATA, data: {...data, ...appendedData}});
  };
